export default __webpack_public_path__ + "static/media/topictech.8b4890cf.mp4";